import React from 'react';

import styles from './Spinner.css';

const Spinner = () => (
  <div className={styles.LdsRoller}>
    <div /><div /><div /><div /><div /><div /><div /><div />
  </div>
);

export { Spinner };



// WEBPACK FOOTER //
// ./src/components/common/Spinner/Spinner.js